// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__NHOaE","productName":"Table_productName__3FEbh"};